<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="start2"></p>
<h2><a id="page8"><span class="bold">YOU CAN SPEND YOUR WHOLE LIFE TRYING</span></a></h2><a id="page8">
<p class="start1"></p>
<p class="center"><img alt="image" src="images/p8.jpg"/></p>
<p class="noindent1">to master flyfishing, and no matter how proficient you become, there will always be more for you to learn. Or, you can enjoy a lazy afternoon on a creek bank trout fishing with your kid. The key to becoming a truly great angler, and to getting the most out of this book, is to recognize that these two ends of the spectrum are not mutually exclusive. If you pursue both with the same zeal, the sport of flyfishing can make you happy your entire life. That’s the goal of the book you’re holding in your hands. <em class="italic">Field &amp; Stream</em> magazine’s experts want to make sure that you have the knowledge, skills, and attitude to have a blast every time you’re on the water.</p>
<p class="indent">For me, the key is to try new things while not forgetting about what you’ve loved in the past. Lately I’ve been obsessed with hiking to small mountain streams to cast tiny flies to small trout that spook as soon as I make a mistake. I’m catching a few, but more important, I’m learning a lot and loving the challenge.</p>
<p class="indent">Joe Cermele, <em class="italic">Field &amp; Stream’</em>s fishing editor and the author of this book, is the ideal guide for this lesson. Cermele has traveled around the world fishing, and he is one of the most talented anglers I’ve ever met. He shares a wealth of tactics, tips, and techniques. Now it’s up to you to go out on the water and find your fun. Go for it.</p>
<p class="start2"></p>
<p class="noindent"><span class="bold">ANTHONY LICATA</span></p>
<p class="noindent">Editor-in-Chief, <em class="italic">Field &amp; Stream</em></p>
</a></div><a id="page8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cap00a.vue?33d02238